import * as React from 'react';
export default function UserPencil() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 7.99a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.45 14.77c-2.36 0-3.9.58-4.93 1.32-.65.47-1.1 1-1.39 1.5-.14.22-.1.4.02.55.14.18.44.36.84.36h4.05a.75.75 0 1 1 0 1.5H7c-.8 0-1.57-.35-2.03-.94a1.94 1.94 0 0 1-.1-2.26c1.03-1.7 3.2-3.55 7.59-3.55.41 0 .75.33.75.75 0 .41-.34.77-.75.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.9 13.34a1.58 1.58 0 0 0-2.23 0l-3.96 3.96a.62.62 0 0 0-.16.3l-.42 1.76a.62.62 0 0 0 .75.75l1.76-.42a.63.63 0 0 0 .3-.16l3.96-3.96c.62-.62.62-1.62 0-2.23Zm-1.34.88a.33.33 0 0 1 .46.46l-3.83 3.84-.6.14.13-.6 3.84-3.84Z",
    clipRule: "evenodd"
  }));
}